import React, { memo } from "react";
import { Box } from "@mui/material";
import { isEmpty } from "lodash-es";
import { serviceColors } from "features/configure/chartColors";
import { TagCloud } from "react-tagcloud";
import EmptyIconStatus from "components/EmptyState/EmptyIconStatus";
import TextDropdown from "../TextDropdown";
import { useIntl } from "react-intl";

const TagCloudComponent = ({
  chartData,
  type,
  fetchMentionsDetail,
  handleExclude,
}) => {
  const { formatMessage } = useIntl();
  const data = chartData?.map((item) => {
    let value = item.value;
    if (value && value.length > 30) {
      value = value.slice(0, 6) + "..." + value.slice(-6);
    }

    return {
      value: value,
      count: item.count,
      _id: item.keywordIds,
    };
  });

  const customRenderer = (tag, size, color) => {
    return (
      <TextDropdown
        key={tag.value}
        style={{ color, fontSize: size }}
        text={tag.value}
        isShowDropdown={!!type}
        options={[
          {
            label: (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  columnGap: 4,
                  padding: "4px 0px",
                }}>
                <i className="meta-crm-icon-ic_message font-size-16" />
                <div
                  style={{
                    whiteSpace: "nowrap",
                    width: "fit-content",
                  }}>{`View mentions with “${tag.value}”`}</div>
              </div>
            ),
            action: () => fetchMentionsDetail({ type, keywordIds: tag._id }),
          },
          {
            label: (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  columnGap: 4,
                  padding: "4px 0px",
                }}>
                <i className="meta-crm-icon-ic_visibilityOff font-size-16" />
                <div>
                  {formatMessage(
                    {
                      id: "communityAnalysis.chart.keywordTrend.exclude",
                    },
                    { keyword: tag.value }
                  )}
                </div>
              </div>
            ),
            action: () =>
              handleExclude({
                excludeType: "keyword",
                platformType: type,
                identifier: {
                  keyword: tag.value,
                  _id: tag._id,
                },
              }),
          },
        ]}
      />
    );
  };

  return isEmpty(chartData) ? (
    <EmptyIconStatus
      icon="wordCloud"
      emptyTitle={formatMessage({ id: "emptyState.cloudChart.title" })}
      emptyDescription={formatMessage({
        id: "emptyState.cloudChart.description",
      })}
    />
  ) : (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        width: "90%",
        margin: "0 auto",
        "& .tag-cloud": {
          display: "flex",
          width: "100%",
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "center",
          gap: "4px",
          padding: "0px 50px",
        },
      }}>
      <TagCloud
        minSize={12}
        maxSize={30}
        tags={data}
        shuffle
        colorOptions={{
          luminosity: "light",
          hue: serviceColors.small[3],
        }}
        renderer={customRenderer}
      />
    </Box>
  );
};

export default memo(TagCloudComponent);
